import type { ReactNode } from 'react';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

export type DashboardSectionRegistration = {
  /** Unique section identifier used to persist its visibility and position. */
  id: string;
  /** Label displayed in the dashboard customization sidebar. */
  label: string;
  /** Content rendered inside the dashboard card. */
  content: ReactNode | HTMLElement;
  /** Initial visibility used before the user saves their dashboard layout. */
  visible?: boolean;
};

/**
 * An event fired when the dashboard is rendered.
 * Return a section or an array of sections to register them on the dashboard.
 *
 * @eventName "flotiq.dashboard.section::add"
 * @memberof FlotiqPlugins.Events
 * @returns {DashboardSectionRegistration|DashboardSectionRegistration[]|null}
 */
export class DashboardAddSectionEvent extends IFlotiqPluginEvent {}
